export const cmsAttendanceColumns = [
    {
        field: "userName",
        headerName: "User Name",
        width: 160,
    },
    {
        field: "email",
        headerName: "User Email",
        width: 160,
    },
    {
        field: "clientNumber",
        headerName: "User Contact No.",
        width: 160,
    },
    {
        field: "serviceName",
        headerName: "Gym Service",
        width: 160,
    },
    {
        field: "monthDate",
        headerName: "Month Date",
        width: 160,
    },
    {
        field: "noOfDaysPresent",
        headerName: "NoOfDaysPresent",
        width: 160,
    },
    {
        field: "noOfDaysAbsent",
        headerName: "NoOfDaysAbsent",
        width: 160,
    },
    {
        field: "branchName",
        headerName: "Branch Name",
        width: 130,
    },
    {
        field: "branchLocation",
        headerName: "Branch Loc",
        width: 130,
    },
];